import type { FaireProductEntity } from "../../entity_types/product";

export const p_2kn3zcakzt: FaireProductEntity = {
  token: "p_2kn3zcakzt",
  type: "product",
  name: 'Taper Candles – 100% Pure Beeswax – Sculpted Pumpkin 10"',
  brandToken: "b_thcq7n2zrb",
  brandName: "Big Dipper Wax Works",
  imageUrl:
    "https://cdn.faire.com/fastly/93129051843ae25fb63f058fd1477785feb81711dbe81b4580dd46e5acea969d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f0731204d81d5a38f51a00b8d23d0d28ba495eed2e99c206a5e25239b45a45bf.png",
  ],
  priceDollars: 10,
  description:
    'Expected ship date: Aug 1st 2026 This is a pre-order item. Orders containing pre-order items ship together once all items are available. If your cart includes multiple pre-order items, your order will ship on the latest estimated ship date.\n\nEach of our sculpted pumpkin tapers is crafted from wax into a charming pumpkin. Combining the most precious of candle waxes with skilled craftsmanship, each taper burns long and even, with a whimsical, sculptural finish — perfect for autumn gatherings, Halloween, or Thanksgiving tablescapes.\n\nProduct Details:\n\n-Includes 2 unscented tapers \n-Dimensions: 10" H x 7/8" D\n-Wax: 100% pure beeswax\n-Wick: 100% cotton (paraffin-free)\n-Eco-friendly, hypoallergenic, and soot-free\n\nLearn more at BigDipperWaxWorks.com.',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:31.686Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
